import axios from 'axios';

class APIClient {
  constructor({ baseUrl = '/v2/' } = {}) {
    this.baseUrl = baseUrl;
  }

  request({ path, method, params = {}, data = {} }, { responseKey } = {}) {
    const apiPath = this.baseUrl;

    const url = `${apiPath}${path}`;

    // console.log('--------------------- API Request ------------------'); // eslint-disable-line
    // console.log(`Url => ${url}`); // eslint-disable-line
    // console.log(`Method => ${method}`); // eslint-disable-line
    // console.log(`Params => ${JSON.stringify(params)}`); // eslint-disable-line
    // console.log(`Data => ${JSON.stringify(data)}`); // eslint-disable-line
    // console.log(`Headers => ${JSON.stringify(headers)}`); // eslint-disable-line
    // console.log('----------------------------------------------------'); // eslint-disable-line

    return new Promise((resolve, reject) => {
      axios({
        url,
        method,
        params,
        data,
        withCredentials: true,
        headers: {},
      })
        .then((response) => {
          const { data: responseData } = response;
          if (responseKey && responseKey !== '') {
            resolve(responseData[responseKey]);
          } else {
            resolve(responseData);
          }
        })
        .catch((error) => {
          let errorData = { errorMessage: 'An unexpected error has occurred' };
          if (error.response && error.response.data) {
            errorData = error.response.data;
          }
          reject(errorData);
        });
    });
  }

  post(path, data, responseKey = null) {
    return this.request({ path, data, method: 'POST' }, { responseKey });
  }

  put(path, data, responseKey = null) {
    return this.request({ path, data, method: 'PUT' }, { responseKey });
  }

  get(path, params, responseKey = null) {
    return this.request({ path, params, method: 'GET' }, { responseKey });
  }

  delete(path) {
    return this.request({ path, method: 'DELETE' });
  }
}

export default APIClient;
